 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"About":"About","AdministratorDashboard~Contact~EditCompanyDetails~EditDocumentTypes~EditEmployees~EditStaffTypes~Emp~ebf80a6b":"AdministratorDashboard~Contact~EditCompanyDetails~EditDocumentTypes~EditEmployees~EditStaffTypes~Emp~ebf80a6b","AdministratorDashboard~ViewDoc":"AdministratorDashboard~ViewDoc","AdministratorDashboard":"AdministratorDashboard","Contact":"Contact","CreateEmployee~EditEmployees~Login~Policies~PricingC~UploadDocument~smspricingComponent":"CreateEmployee~EditEmployees~Login~Policies~PricingC~UploadDocument~smspricingComponent","EditEmployees":"EditEmployees","Policies":"Policies","EditCompanyDetails":"EditCompanyDetails","EditDocumentTypes":"EditDocumentTypes","EditStaffTypes":"EditStaffTypes","Employees":"Employees","ViewDoc":"ViewDoc","CountryFlag":"CountryFlag","EditColorTheme":"EditColorTheme","EmployeeDashboard":"EmployeeDashboard","Faq":"Faq","NotLoggedIn":"NotLoggedIn","PmtCancel":"PmtCancel","PmtSuccess":"PmtSuccess","Pricing":"Pricing","PrivacyPolicy":"PrivacyPolicy","Settings":"Settings","Terms":"Terms","CreateEmployee":"CreateEmployee","UploadDocument":"UploadDocument","VueNumericInput":"VueNumericInput","pdfjsWorker":"pdfjsWorker","Login":"Login","RegisterC":"RegisterC","Cookie":"Cookie","PromoVideo":"PromoVideo","PricingC~smspricingComponent":"PricingC~smspricingComponent","PricingC":"PricingC","smspricingComponent":"smspricingComponent","Password":"Password"}[chunkId]||chunkId) + "." + {"About":"b3ae30b4","AdministratorDashboard~Contact~EditCompanyDetails~EditDocumentTypes~EditEmployees~EditStaffTypes~Emp~ebf80a6b":"accb4e4c","AdministratorDashboard~ViewDoc":"65c1a031","AdministratorDashboard":"95c99299","Contact":"afa34a87","CreateEmployee~EditEmployees~Login~Policies~PricingC~UploadDocument~smspricingComponent":"e9af2a1d","EditEmployees":"d4f652f1","Policies":"45acdddc","EditCompanyDetails":"119c557b","EditDocumentTypes":"158187f9","EditStaffTypes":"23a0d9d6","Employees":"b7dd13a5","ViewDoc":"a0f62a8f","CountryFlag":"4e3db161","EditColorTheme":"d8cf4db2","EmployeeDashboard":"15fc5b11","Faq":"c875aca1","NotLoggedIn":"104cecfb","PmtCancel":"267cc911","PmtSuccess":"177f9124","Pricing":"9fef4ea2","PrivacyPolicy":"ae1a77d1","Settings":"313d3dfb","Terms":"472c014b","CreateEmployee":"9b565571","UploadDocument":"8f084c99","VueNumericInput":"ba338148","pdfjsWorker":"3611b4e0","Login":"c7631190","RegisterC":"9e17075d","Cookie":"ae52019e","PromoVideo":"53455bee","PricingC~smspricingComponent":"44653f2e","PricingC":"8fe507ed","smspricingComponent":"8202f1ad","Password":"def64b13"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"About":1,"AdministratorDashboard~Contact~EditCompanyDetails~EditDocumentTypes~EditEmployees~EditStaffTypes~Emp~ebf80a6b":1,"AdministratorDashboard":1,"Contact":1,"CreateEmployee~EditEmployees~Login~Policies~PricingC~UploadDocument~smspricingComponent":1,"EditEmployees":1,"Policies":1,"EditCompanyDetails":1,"EditDocumentTypes":1,"EditStaffTypes":1,"Employees":1,"ViewDoc":1,"EditColorTheme":1,"EmployeeDashboard":1,"Faq":1,"NotLoggedIn":1,"PmtCancel":1,"PmtSuccess":1,"PrivacyPolicy":1,"Settings":1,"Terms":1,"CreateEmployee":1,"UploadDocument":1,"Login":1,"RegisterC":1,"Cookie":1,"PromoVideo":1,"PricingC~smspricingComponent":1,"PricingC":1,"smspricingComponent":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"About":"About","AdministratorDashboard~Contact~EditCompanyDetails~EditDocumentTypes~EditEmployees~EditStaffTypes~Emp~ebf80a6b":"AdministratorDashboard~Contact~EditCompanyDetails~EditDocumentTypes~EditEmployees~EditStaffTypes~Emp~ebf80a6b","AdministratorDashboard~ViewDoc":"AdministratorDashboard~ViewDoc","AdministratorDashboard":"AdministratorDashboard","Contact":"Contact","CreateEmployee~EditEmployees~Login~Policies~PricingC~UploadDocument~smspricingComponent":"CreateEmployee~EditEmployees~Login~Policies~PricingC~UploadDocument~smspricingComponent","EditEmployees":"EditEmployees","Policies":"Policies","EditCompanyDetails":"EditCompanyDetails","EditDocumentTypes":"EditDocumentTypes","EditStaffTypes":"EditStaffTypes","Employees":"Employees","ViewDoc":"ViewDoc","CountryFlag":"CountryFlag","EditColorTheme":"EditColorTheme","EmployeeDashboard":"EmployeeDashboard","Faq":"Faq","NotLoggedIn":"NotLoggedIn","PmtCancel":"PmtCancel","PmtSuccess":"PmtSuccess","Pricing":"Pricing","PrivacyPolicy":"PrivacyPolicy","Settings":"Settings","Terms":"Terms","CreateEmployee":"CreateEmployee","UploadDocument":"UploadDocument","VueNumericInput":"VueNumericInput","pdfjsWorker":"pdfjsWorker","Login":"Login","RegisterC":"RegisterC","Cookie":"Cookie","PromoVideo":"PromoVideo","PricingC~smspricingComponent":"PricingC~smspricingComponent","PricingC":"PricingC","smspricingComponent":"smspricingComponent","Password":"Password"}[chunkId]||chunkId) + "." + {"About":"8d9ec804","AdministratorDashboard~Contact~EditCompanyDetails~EditDocumentTypes~EditEmployees~EditStaffTypes~Emp~ebf80a6b":"99240f65","AdministratorDashboard~ViewDoc":"31d6cfe0","AdministratorDashboard":"f185bdee","Contact":"6906a6b7","CreateEmployee~EditEmployees~Login~Policies~PricingC~UploadDocument~smspricingComponent":"9fc83cdb","EditEmployees":"5c3d1f01","Policies":"be44831f","EditCompanyDetails":"7ff1ff17","EditDocumentTypes":"20d0b203","EditStaffTypes":"134fd929","Employees":"ec8e7f62","ViewDoc":"5fcdfdac","CountryFlag":"31d6cfe0","EditColorTheme":"93eec328","EmployeeDashboard":"8e874584","Faq":"e2e1376b","NotLoggedIn":"9f324954","PmtCancel":"534ff19b","PmtSuccess":"448b36c0","Pricing":"31d6cfe0","PrivacyPolicy":"c6129015","Settings":"5e51803f","Terms":"0648979a","CreateEmployee":"47af6a57","UploadDocument":"3d9d8bd3","VueNumericInput":"31d6cfe0","pdfjsWorker":"31d6cfe0","Login":"775b8de9","RegisterC":"1572027d","Cookie":"20e93c15","PromoVideo":"0668100e","PricingC~smspricingComponent":"02f1f5ef","PricingC":"ae772cdd","smspricingComponent":"2d2a320f","Password":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
